export default "__VITE_ASSET__Dmbio1pi__"